const mutations = {
    SET_LOADING(state,payload){
        state.isLoading = payload
    },
    TOGGLE_SILDER(state,payload){
        state.siderbarOpen=payload.siderbarOpen
    },
    SET_IS_MOBILE(state,payload){
        state.isMobile = payload
    },
    SET_USER_INFO(state,payload){
        state.userInfo = payload
    },
    SET_DEVICE_INFO(state,payload){
        state.deviceInfo = payload
    },
    SET_DEVICE_LIST_TYPE(state,payload){
        state.deviceListType = payload
    },
    SET_STAND_DATA(state,payload){
        state.standTempData = payload
    },
    SET_PLAYER_DATA(state,payload){
        state.playerData = payload
    }

}
export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js